let repaymentFormulaOptions= [
  {
    label: '到期一次还款付息',
    value: 'DQHK'
  },
  {
    label: '等额本息',
    value: 'DEBX'
  },
  {
    label: '等本等息',
    value: 'DBDX'
  },
  {
    label: '先息后本',
    value: 'XXHB'
  },
]

export default repaymentFormulaOptions



// WEBPACK FOOTER //
// ./src/utils/repaymentFormulaOptions.js